<template>
  <v-container fluid class="px-lg-5">
    <app-header :title="title" :breadcrumbs="breadcrumbs" :showButton="false" />
    <table-filter @filterTable="onYearFilter" :items="yearOptions"
      :label="$t('models.appraisal.attributes.year')" />
    <v-card class="rounded-card" flat outlined>
      <v-data-table :headers="headers" :items="appraisals.items" :options.sync="options"
        @update:options="updateOptions" :server-items-length="appraisals.count" :loading="loading"
        :no-data-text="$t('messages.emptyState', { entity: $tc('models.appraisal.entity', 2) })"
        :no-results-text="$t('messages.emptyState', { entity: $tc('models.appraisal.entity', 2) })" flat>
        <template v-slot:[`item.employeeName`]="{ item }">
          {{ item.employeeName }}
        </template>
        <template v-slot:[`item.year`]="{ item }">
          {{ appraisalYear(item) }}
        </template>
        <template v-slot:[`item.title`]="{ item }">
          {{ item.title }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip small :color="statusColors[item.status]" text-color="white">
            {{ $t(`models.appraisal.attributes.statuses.${item.status}`) }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip v-if="isDownloadable(item)" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small @click="downloadPdf(item)" v-on="on" v-bind="attrs">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('actions.export') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {appraisalStatuses, appraisalStatusColors} from 'constants';

export default {
  name: 'AppraisalStatus',
  data() {
    const currentYear = new Date().getFullYear();
    return {
      yearOptions: [currentYear, currentYear - 1, currentYear - 2],
      statusColors: appraisalStatusColors,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [true],
        mustSort: ['true'],
        multiSort: false,
        filterBy: {
          year: currentYear
        }
      },
      title: {
        text: this.$t('layout.mainMenu.appraisalStatus'),
        icon: 'mdi-progress-check'
      },
      breadcrumbs: [
        {
          text: this.$t('layout.mainMenu.home'),
          to: {name: 'Home'}
        },
        {
          text: this.$t('layout.mainMenu.appraisalStatus'),
          to: {name: 'AppraisalStatus'},
          exact: true
        }
      ],
      headers: [
        {
          text: this.$t('models.appraisal.attributes.employee'),
          value: 'employeeName',
          sortable: false
        },
        {
          text: this.$t('models.appraisal.attributes.year'),
          value: 'year',
          sortable: false
        },
        {
          text: this.$t('models.appraisal.attributes.title'),
          value: 'title',
          sortable: false
        },
        {
          text: this.$t('models.appraisal.attributes.status'),
          value: 'status',
          sortable: false
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          width: '80px'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['appraisals'])
  },
  methods: {
    ...mapActions(['getAppraisals', 'downloadAppraisalPdf']),
    updateOptions(options) {
      this.loading = true;
      this.getAppraisals(options).then(() => (this.loading = false));
    },
    onYearFilter(year) {
      this.options.page = 1;
      this.options.filterBy.year = year;
      this.updateOptions(this.options);
    },
    appraisalYear(appraisal) {
      const date = appraisal.completedAt || appraisal.updatedAt;
      return date ? new Date(date).getFullYear() : '';
    },
    isDownloadable(appraisal) {
      return appraisal.status === appraisalStatuses.COMPLETED;
    },
    downloadPdf(appraisal) {
      this.downloadAppraisalPdf({
        id: appraisal.id, filename: `${appraisal.employeeName} - ${appraisal.title}.pdf`
      });
    }
  }
};
</script>
